const SET = 'serverRendered/SET'

export const setServerRendered = serverRendered => {
  return {
    serverRendered,
    type: SET,
  }
}

export default (state = false, action) => {
  switch (action.type) {
    case SET:
      return action.serverRendered
    default:
      return state
  }
}
